export default {
  title: {
    en: 'This email is already in use',
  },
  text: {
    en: `
    This email has already been used with another account:<br />
    choose a different email, or merge accounts by submitting your password.
  `,
  },
  errorMsg: {
    en: 'The password is not valid',
  },
  btnOk: {
    en: 'Ok',
  },
}
